import Link from 'next/link';
import { memo } from 'react';
import { IFooterSectionProps } from './FooterSection.types';
import styles from './styles.module.scss';

export const FooterSection = memo<IFooterSectionProps>(({ title, href: headerHref, links }) => (
  <div className={styles.container}>
    <Link className={styles.headerText} href={headerHref}>
      {title}
    </Link>
    {links.map(({ text, href: linkHref, prefix }) => (
      <Link key={text} className={styles.subHeaderText} href={linkHref}>
        {prefix && <p className={styles.prefix}>{prefix}</p>} {text}
      </Link>
    ))}
  </div>
));

FooterSection.displayName = 'FooterSection';

export default FooterSection;
